// frontend/src/components/Services.jsx

import React from 'react';
import { Briefcase, Anchor } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Services() {
  return (
    <section className="py-12 bg-gray-50" id="services">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-8">Our Specialized AI Solutions</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Card 1 */}
          <div className="bg-white rounded-lg shadow p-6">
          <div className="mb-4 flex justify-center">
              <Anchor className="w-12 h-12 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">Vertical AI Agents for Maritime Industry</h3>
            <p className="text-gray-600 mb-4">
              Specialized AI solutions to assist Maintenance Engineers, Ship Inspectors, and Ship Captains.
            </p>
            {/* Use <Link> instead of <a href> */}
            {/* <Link
              to="/maritime-ai"
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Learn More
            </Link> */}
            <a
              href="#contact"
              className="mt-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
            Learn More
            </a>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg shadow p-6">
          <div className="mb-4 flex justify-center">
            <Briefcase className="w-12 h-12 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold mb-2">AI DreamTeam Platform for Small Business</h3>
            <p className="text-gray-600 mb-4">
              Tailored AI Agents to boost efficiency and growth for small businesses.
            </p>
            <a
              href="#contact"
              className="mt-auto px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
            Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
